import React from "react";
import { observer } from "mobx-react-lite";
import { Flex, Typography, useTheme } from "@ugc-ui/lego";
import { useStores } from "@client/store";
import { formatDate } from "@common/utils/date";
import { StatisticChart } from "@client/pages/ShowCampaign/components/StatisticChart";
import { GeneralInfo } from "@client/pages/ShowCampaign/components/GeneralInfo";
import { getStatusColor } from "@common/utils/getStatusColor";
import { DownloadTableButton } from "@common/components/DownloadTableButton/DownloadTableButton";
import { CampaignReviewData } from "@common/api/__generated__";
import { EndDateField } from "@common/typings/common";
import { isExportDisable } from "@common/utils/statistic";
import { Spacer } from "@common/components/Statistic/ChartCustomTooltip.styled";

interface Props {
  campaign: CampaignReviewData;
}

export const ShowCampaignTabStatisticTouch: React.FC<Props> = observer(
  ({ campaign }) => {
    const {
      campaignStatisticStore: {
        totalStatistic,
        mobileChartData,
        startExport: handleExport,
      },
    } = useStores();
    const theme = useTheme();

    const disabled = isExportDisable(campaign.status.id, totalStatistic);

    return (
      <Flex flexDirection="column" gap={16}>
        <Flex justifyContent="space-between" alignItems="center">
          <Typography
            type="subtitle2"
            dataCy="заголовок страницы кампании"
            color={getStatusColor(theme, campaign.status)}
          >
            {campaign.status.name}
          </Typography>
          <DownloadTableButton
            onDownloadCallback={handleExport}
            text="Отчет"
            isMobile
            disable={disabled}
            wideButton
          />
        </Flex>
        <GeneralInfo
          creationDate={formatDate(campaign.dateCreate)}
          endDate={formatDate(campaign[EndDateField[campaign.status.id]])}
          startDate={formatDate(campaign.dateStart)}
        />
        <Spacer />

        <StatisticChart
          chartData={mobileChartData}
          title="Показы видео"
          dataKey="viewsCount"
          tooltipText="Показы видео — количество уникальных показов рекламной кампании"
          totalValue={Number(totalStatistic.viewsCount.all)}
        />

        <StatisticChart
          chartData={mobileChartData}
          title="Клики"
          dataKey="clicksCount"
          tooltipText="Клики — количество уникальных кликов-переходов по рекламной кампании"
          totalValue={Number(totalStatistic.clicksCount.all)}
        />

        <StatisticChart
          chartData={mobileChartData}
          title="Пользователи"
          dataKey="uniqUsersCount"
          tooltipText="Уникальные пользователи — количество уникальных пользователей, которым была показана рекламная кампания"
          totalValue={Number(totalStatistic.uniqUsersCount.all)}
        />
      </Flex>
    );
  }
);
